import { render, staticRenderFns } from "./ItensCarrinho.vue?vue&type=template&id=30073282&scoped=true"
import script from "./ItensCarrinho.vue?vue&type=script&lang=js"
export * from "./ItensCarrinho.vue?vue&type=script&lang=js"
import style0 from "./ItensCarrinho.vue?vue&type=style&index=0&id=30073282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30073282",
  null
  
)

export default component.exports